import { ID } from '@griply/types';

import {
  getLinkedItemColor,
  GetLinkedItemColorOptions,
} from './get-linked-item-color';

// The colour a form seeds a new or re-linked goal with: the first parent goal's, else the first
// life area's. A parent that resolves to no colour ends the walk — it does not fall through to
// the life area, so the seed matches what the goal will actually render under that parent.
export const resolveLinkSeedColor = (
  parentIds: ID[] | null | undefined,
  lifeAreaIds: ID[] | null | undefined,
  options: GetLinkedItemColorOptions,
): string | null => {
  const seedId = parentIds?.[0] ?? lifeAreaIds?.[0];

  return seedId ? getLinkedItemColor(seedId, options) : null;
};
